import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/MonthlyReports`;

class MonthlyReportService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getMonthlyReportList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "list" });
    } catch (e) {
      throw e;
    }
  }

  public getMonthlySummaryDashboard(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "monthly/dashboard" });
    } catch (e) {
      throw e;
    }
  }

  public getMonthlyReportDetails(id: number): Promise<IApiResponse | void> {
    try {
      return super.getById(id);
    } catch (e) {
      throw e;
    }
  }

  public updateMonthlyReport(planId: number, body: any): Promise<IApiResponse | void> {
    try {
      return super.update(body, planId);
    } catch (e) {
      throw e;
    }
  }

  // public removeMonthlyReport(id: number): Promise<IApiResponse | void> {
  //   try {
  //     return super.delete(id);
  //   } catch (e) {
  //     throw e;
  //   }
  // }

  public removeMonthlyReport(planID: number): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${planID}/monthlyReport`;
      return super.delete();
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public deleteActualResultAgreement(
    agreementId: number,
    planExistID: number,
    monthlyReportPlanId: number
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/actualResultAgreement/${agreementId}/${planExistID}/${monthlyReportPlanId}`;
      return super.delete();
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public updateActualResultPlan(
    planExistID: number,
    monthlyReportPlanId: number,
    body: { borrowDate: string; repayDate: string }
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/actualResultPlan/${planExistID}/${monthlyReportPlanId}`;
      return super.updatelist(body);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

}
const monthlyReportAPI = new MonthlyReportService(url);
export default monthlyReportAPI;
